import React from 'react'
import Link from 'gatsby-link'

const FleetBreadcrum = ({ lang, currentPage }) => {
  if (lang == 'en') {
    return (
      <ul key={lang} className="breadcrumb">
        <li>
          <Link to={`/${lang}/fleet`}>Fleet</Link>
        </li>
        <li>{currentPage}</li>
      </ul>
    )
  } else if (lang == 'es') {
    return (
      <ul key={lang} className="breadcrumb">
        <li>
          <Link to={`/${lang}/fleet`}>Flota</Link>
        </li>
        <li>{currentPage}</li>
      </ul>
    )
  }
}

export default FleetBreadcrum



// WEBPACK FOOTER //
// ./src/menus/FleetBreadcrum.js